import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-project-processes',
  templateUrl: './project-processes.component.html',
  styleUrls: ['./project-processes.component.css']
})
export class ProjectProcessesComponent implements OnInit {
    projectKeyno;

    public setting?: Setting;

    public itemsListPosts: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.projectKeyno = this.stateService.getStateParams()['project_keyno'];
    }

    private async loadSetting() {
        if (!!this.projectKeyno) {
            this.setting = (await this.datatask.Post(906, { project_keyno: this.projectKeyno }))[0];
        }
    }

    private async loadPosts() {
        if (!this.setting) return;

        return this.itemsListPosts = await this.datatask.Post(907, { project_keyno: this.setting.project_keyno });
    }

    private async init() {
        await this.loadSetting();
        this.loadPosts();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    project_keyno: string;
    heading: string;
}
